import { Component, OnInit, AfterViewInit, AfterContentInit, Output, EventEmitter, ViewChild, ViewChildren, ViewContainerRef, QueryList, ComponentFactoryResolver, Renderer2, ComponentRef, Type as AngularCoreType, ElementRef, Input } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';

import { DateAdapter } from '@angular/material/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { ProgressBarMode } from '@angular/material/progress-bar';
import { MatMenuTrigger } from '@angular/material/menu';
import { TooltipPosition } from '@angular/material/tooltip';

import { FormFieldBaseComponent } from '../form-field-base/form-field-base.component';
import { IFieldNameToFormField } from '../../../interfaces/iform-field-component';
import { FormField } from '../../../models/form-builder/form-field.model';
import { GridRowViewModel } from '../../../models/form-builder/grid-row.model';
import { FormInstanceElement, FormInstanceElementValueTypeEnum } from '../../../models/form-builder/form-instance-element.model';
import { IFormFieldDisplayHint } from '../form-field-base/form-field-base.component';
import { DynamicComponentHostDirective } from '../../../directives/dynamic-content-host.directive';
import { FieldDefinition } from '../../../models/form-builder/field-definition.model';
import { IFieldDefinitionLogic } from '../../../interfaces/ifield-definition-logic.interface';
import { FieldDefinitionService } from '../../../services/field-definition.service';
import { FormFieldTypeAndNameService } from '../../../services/form-field-type-and-name.service';
import { FormFieldPropertyEnum } from '../../../models/form-builder/form-field-property-enum.model';
import { FormInstanceElementRequest } from '../../../models/form-instance-element-request.model';
import { ProgressBarConstants } from '../../../enums/progress-bar-constants.enum';
import { FormFieldProcessingPhaseEnum } from '../../../enums/form-field-processing-phase.enum';
import { IGridRow } from '../../../interfaces/grid-row.interface';
import { ComponentAndFormField } from '../../../models/grid/component-and-form-field-model';
import { RuntimeMetadata } from '../../../models/grid/runtime-metadata.model';
import { GridRuntimeData } from '../../../models/grid/runtime-data.model';
import { GridCellContextMenuInfo } from '../../../models/grid/cell-context-menu-info.model';
import { LoadingDataProgressInfo } from '../../../models/grid/loading-data-progress.model';
import { FieldTypeAndName, IFieldTypeToFieldInfo, } from '../../../services/form-field-type-and-name.service';
import { CachedFormFieldService } from '../../../services/form-field-with-cache.service';
import { FormFieldConstraintLiaisonManager } from '../../form-builder/properties/form-field-properties/constraints/field-constraint-liaison-manager';
import { CurrentSiteService } from '../../../services/current-site.service';
import { CurrentUserService } from '../../../../security/current-user.service';
import { CsvOptionsFileData } from '../../../models/csv-data/csv-options-file-data.model';
import { FixedFirstColumnValues } from '../../../models/grid/fixed-first-column-values.model';

import { ShortTextFieldType, RichTextFieldType } from '../../../models/form-builder/form-field-types';

import { GridConfig } from '../../../models/grid/grid-config.model';
import { GridFormInstanceElementWrapper } from '../../../models/grid/grid-form-instance-element-wrapper.model';
import { IGetCellDisplayValue } from '../../../models/grid/grid-interfaces';
import { GridRowDef } from '../../../models/grid/grid-row.model';
import { GridAllModesDataSource } from '../../../models/grid/grid-data-source.model';
import { AttachmentService } from '../../../services/attachment.service';
import { FormFieldOnInitPropertyEnum } from '../../../models/form-builder/form-field-on-init-output-property.enum';
import { UtilityHelper } from '../../../utility.helper';
import { IFormFieldConstraint } from '../../../interfaces/iform-field-constraint.interface';
import { IFormFieldConstraintLiaison } from '../../form-builder/properties/form-field-properties/constraints/ifield-constraint-liason.interface';
import { FormFieldConfigurationSaveReason } from '../../../enums/form-field-save-config-reason.enum';
import { SortDirection } from '../../../enums/sort-direction.enum';
import { GridFieldDesignerComponent } from '../grid-field-designer/grid-field-designer.component';
import { GridFieldEditorComponent } from '../grid-field-editor/grid-field-editor.component';
import { ConditionalLogicColumnDefsFilterData } from '../grid-field-editor/grid-field-editor.component';
import { ColumnReorderConfig, ColumnBase } from "@progress/kendo-angular-grid";
import { GridFlavorEnum, GridFlavorModifiersEnum } from '../../../enums/grid.enums';
import { FormModeEnum } from '../../../enums/form-mode.enum';

// code commented out with "// Commented out for VNEXT-1429 (remove old grid)" note above it
// can be deleted once we're sure this is all working ok

// Define constants used below.
const GRID_ROW_ID_KEY: string = 'gridRowId';
const GRID_COLUMN_ID_KEY: string = 'gridColumnId';
const DEFAULT_UNSELECTED_ROW_HEIGHT: number = 48;

// Implement the grid form field component.
//
// Note:  please note the 'providers' definition below, as it is needed.
//        Without it, you will get the following exception:
//
//             No value accessor for form control with unspecified name
//
// The above exception gets thrown when a component, in this case our
// base class, implements interface 'ControlValueAccessor' and does not
// provide the 'providers' definition below.  Implementing the
// 'ControlValueAccessor' interface allows a form field component to
// support [(ngMode)], so users of the component can use [(ngModel)].
@Component({
    selector: 'app-grid-form-field',
    templateUrl: './grid-form-field.component.html',
    styleUrls: ['./grid-form-field.component.scss', '../form-fields.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: GridFormFieldComponent,
            multi: true
        }
    ],
    standalone: false
})
export class GridFormFieldComponent extends FormFieldBaseComponent implements OnInit, AfterViewInit, AfterContentInit, IGetCellDisplayValue {
    // Properties.
    @Input() showExportToExcelButton: boolean = true;
    @Input() isFootnotesGrid: boolean = false;
    // BEGIN ADDED FOR NEW ATTACHMENTS (TODO: DO THESE NEED TO BE INPUTS? I DON'T THINK SO)
    @Input() flavor: GridFlavorEnum = GridFlavorEnum.RegularGrid; // An alternative flavor of Attachments Grid can be set
    @Input() flavorModifier: GridFlavorModifiersEnum; // for example, when the flavor is AttachmentsGrid, this can be 'showAll' or 'latestOnly'
    @Input() userCanAdmin: boolean;
    // END ADDED FOR NEW ATTACHMENTS

    // Note:  several properties are implemented in my base class.
    @Output() onInit = new EventEmitter();
    // Emitted by design mode changes like adding/deleting/reordering a column
    @Output() designChange = new EventEmitter();
    // Request a form instance element load.
    @Output() loadFormInstanceElement = new EventEmitter();
    @Output() onEdit = new EventEmitter(); // For editing a column's properties.

    //TEAMS-894: KLW - Needed for grid validation
    @Output() mainGridValidation = new EventEmitter();

    @Output() conditionalLogicInstructions = new EventEmitter(); // VNEXT-1383, in particular the third use case.

    // PJH - 10/1/2025 - added for VNEXT-1823
    @Output() flaggedAsDirty = new EventEmitter();
    @Output() flaggedAsClean = new EventEmitter();

    // Define read only data.
    private readonly formFieldProperties: string[] =
        [
            FormFieldPropertyEnum.REQUIRED,
            FormFieldPropertyEnum.DISPLAY_NAME,
            FormFieldPropertyEnum.INSTRUCTIONS_TEXT,
            FormFieldPropertyEnum.FIXED_FIRST_COLUMN_FILE,
            FormFieldPropertyEnum.FOOTER,
            FormFieldPropertyEnum.EXCEL_IMPORT_EXPORT_TEMPLATE,
            FormFieldPropertyEnum.DISPLAY_KENDO_GRID_ROWS, //VNEXT-980: KLW - Property to set the number of Kendo grid rows to display
            FormFieldPropertyEnum.GRID_PERMISSIONS,
            FormFieldPropertyEnum.GRID_KEY_COLUMNS, // Note:  related to environmental justice (EJ) requirements for importing grid data from Excel files.
            FormFieldPropertyEnum.HIDE_GRID_FILTERING, // https://maxjira.max.gov/browse/VNEXT-1252
            FormFieldPropertyEnum.HIDE_GRID_BODY, // VNEXT-1378
            FormFieldPropertyEnum.DISABLE_GRID_ROW_DELETE,
            FormFieldPropertyEnum.PRESET_FILTERS
        ];

    // Column definitions.
    // Note:  the following initialization is now performed in the grid form field's constructor.
    private gridConfig: GridConfig = null;

    // Design mode data structures.
    private allModesDataSource: GridAllModesDataSource = null;

    private runtimeMetadata: RuntimeMetadata = new RuntimeMetadata();
    private runtimeData: GridRuntimeData = new GridRuntimeData();

    private formFieldDisplayHints: IFormFieldDisplayHint = {};

    // PJH - 6/29/2026 - VNEXT-2284 - introduced this property to tell the component to ignore any previously saved validation error message for the Grid.
    //                                It get sets to true in GridFieldEditorComponent as soon as a user clicks into a Grid to edit it. 
    public ignoreAnySavedValidationState: boolean = false;

    // This references all of the templates in a row which look like this in the HTML:
    @ViewChildren(DynamicComponentHostDirective, { read: DynamicComponentHostDirective }) dynamicComponentHosts: QueryList<DynamicComponentHostDirective>;
    @ViewChild(GridFieldEditorComponent, { read: GridFieldEditorComponent }) gridFieldEditorComponent: GridFieldEditorComponent;

    // Define instance data used with a MatPaginator.
    @ViewChild('matPaginatorMatFooter', { read: MatPaginator }) matPaginator;
    private loadingDataProgress: LoadingDataProgressInfo = new LoadingDataProgressInfo();
    // 01-20-2021 note:  added the following instance variable.
    //
    //                   Might want to revisit the grid's direct
    //                   use of the service as it is not
    //                   consistent with existing architectural
    //                   norms.
    //
    //                   Will consider other options and revisit.
    //private formInstanceService: FormInstanceService = null;
    // End instance data used with a MatPaginator.

    // Define properties related to a design mode context menu.
    @ViewChild(MatMenuTrigger)
    gridCellContextMenu: MatMenuTrigger;
    // End properties related to a design mode context menu.

    @ViewChildren(FormFieldBaseComponent, { read: FormFieldBaseComponent }) formFieldComponentsQueryList: QueryList<FormFieldBaseComponent>;

    // Constructor.
    public constructor(private resolver: ComponentFactoryResolver,
        private hostElement: ElementRef,
        private renderer: Renderer2,
        private attachmentService: AttachmentService, //TEAMS-424: KLW - Need reference to attachment service
        private dialog: MatDialog, //TEAMS-424: KLW - Need reference to Material Dialog
        private cachedFormFieldConstraintsService: CachedFormFieldService,
        private currentSiteService: CurrentSiteService,
        private currentUserService: CurrentUserService,
        private dateAdapter: DateAdapter<Date>,
        private fieldDefinitionService: FieldDefinitionService,
        private formFieldTypeAndNameService: FormFieldTypeAndNameService) {
        super();

        this.formFieldProperties.push(FormFieldPropertyEnum.READ_ONLY);

        // Create a blank config.
        this.createEmptyGridConfig();

        this.formFieldTypeAndNameService.initializeFieldTypesAndNames(this.renderer, this.dateAdapter, this.attachmentService, this.dialog);

        // Define a display hint to pass to contained form fields.
        this.formFieldDisplayHints["showLabel"] = false;

        return;
    }

    // Implement abstract methods.
    public getProperties(): any {
        let hshEventProperties = {
            component: this,
            formField: this.FormField,
            properties: this.formFieldProperties,
            displayFormatValues: null,

            saveConfigurationRequired: true,
            saveDataRequired: true,

            propertyUpdateRequired: true
        };

        return (hshEventProperties);
    }

    // Life cycle methods.
    public ngOnInit(): void {
        // Note:  even though a blank config is created in this class's
        //        constructor, we need to create a blank config here.
        this.createEmptyGridConfig();

        // If we have an existing grid configuration, use it.
        if ((this.FormField.childFormFields) && (this.FormField.childFormFields.length > 0)) {
            this.createGridConfig();

            // Do we have a fixed first column?
            if (this.hasFixedFirstColumnJsonConfig) {
                // Note:  the following line makes it easier to check if a grid has a fixed first column configuration.
                this.FormField.fixedFirstColumnJson = this.gridConfig.getColumnDef(0).fixedFirstColumnJson;
                this.FormField.transientFixedFirstColumnValues = FixedFirstColumnValues.createFromJson(this.gridConfig.getColumnDef(0).fixedFirstColumnJson);
            }
        }

        // Create data structures for our given operating mode.
        this.allModesDataSource = new GridAllModesDataSource(this.gridConfig, this);

        // Let my parent component know my configuration.
        let hshEventProperties = this.getProperties();

        this.onInit.emit(hshEventProperties);

        if (this.Mode === 'design') {
            this.allModesDataSource.addRow();

            // Set a form field constraint updated callback.
            this.FormField.setConstraintUpdatedCallback(this.formFieldConstraintUpdated);
            this.FormField.setAcceptsConstraintUpdateFrom(this.acceptsConstraintUpdateFrom);
        }

        return;
    }

    public ngAfterContentInit(): void {
        return;
    }

    // PJH - 1/23/2026 - VNEXT-2184 - override of base class method to enable validation of Grid's required status
    public CheckFieldForValidation() {
        const statusChangeName = this.FieldHasValidationError ? FormFieldPropertyEnum.INVALID : FormFieldPropertyEnum.VALID;
        if (this.mode != FormModeEnum.DESIGN) {
            this.emitValidation(statusChangeName);
        }
    }

    // PJH - 1/23/2026 - VNEXT-2184 - override of base class method to enable validation of Grid's required status
    // See https://community-dc.max.gov/x/Wwtao for detailed walkthru of validation
    public get FieldHasValidationError() {
        return (this.FormField.required && !this.gridFieldEditorComponent.HasRows) || this.fieldHasValidationError || this.FormInstanceElement.gridValidationMessage != null;
    }

    // PJH - 1/23/2026 - VNEXT-2184 - override of base class method to enable validation of Grid's required status
    // PJH - 3/5/2026  - VNEXT-2242 - updated it to add a check for any invalid rows
    public getValidationErrors(revealValidationErrors: boolean = false): string[] {

        let errorMessageToDisplay: string = null;
        if (this.FormField.required && !this.gridFieldEditorComponent.HasRows) {
            errorMessageToDisplay = `${this.FormField.displayName || this.FormField.name} is required but has no rows`;
        } else if (this.gridFieldEditorComponent.AtLeastOneFieldIsInvalid) {
            
            errorMessageToDisplay = `${this.FormField.displayName || this.FormField.name} has an invalid row`;
        }
        if (errorMessageToDisplay) {
            this.fieldHasValidationError = true;
            return [errorMessageToDisplay];
        } else {
            this.fieldHasValidationError = false;
            return [];
        }
    }

    // Override base class/FormFieldComponent methods.
    public isCompoundObjectComponent(): boolean {
        // Note:  this method is also used in apply conditional logic.
        return true;
    }
    public resetConditionalLogicSettings(): void {
        // Try to pass this on to my grid field editor component.
        if (this.gridFieldEditorComponent != null)
            this.gridFieldEditorComponent.resetConditionalLogicSettings();
    }
    public applyChildFieldAttributes(childFieldName: string, showChildField: boolean, childFieldIsReadOnly: boolean, childFieldIsRequired: boolean): void {
        // Try to pass this on to my grid field editor component.
        if (this.gridFieldEditorComponent != null)
            this.gridFieldEditorComponent.applyChildFieldAttributes(childFieldName, showChildField, childFieldIsReadOnly, childFieldIsRequired);
    }
    public formFieldUpdated(): void {
        // Let the grid field editor component handle this method.
        if (this.gridFieldEditorComponent != null) {
            this.gridFieldEditorComponent.formFieldUpdated();
        }            
    }

    // Define methods called by my HTML code.
    public get FormField(): FormField {
        return this.formField;
    }
    public get GridConfig(): GridConfig {
        return this.gridConfig;
    }
    public get RuntimeMetadata(): RuntimeMetadata {
        return this.runtimeMetadata;
    }
    public get RuntimeData(): GridRuntimeData {
        return this.runtimeData;
    }

    public get AllModesDataSource(): GridAllModesDataSource {
        return this.allModesDataSource;
    }
    public get SelectedGridRowIndex(): number {
        return this.runtimeData.selectedGridRowIndex;
    }
    public get SectedGridColumnIndex(): number {
        return this.runtimeData.selectedGridColumnIndex;
    }
    // Used by GridEditorComponent
    public ColumnIsSticky(colName: string): boolean {
        // Note:  this does not need to be a hard code value, but it is.
        return true;
    }
    // Commented out for VNEXT-1429 (remove old grid)
    //public get HeaderRowIsSticky(): boolean {
    //    return true;
    //}

    public get ShowNumericTotalsFooter(): boolean {
        return (this.FormField ? this.FormField.showFooter === true : false);
    }
    // Commented out for VNEXT-1429 (remove old grid)
    //public getNumericFooterTotalValueFor(colIndex: number, columnDef: FormField): string {
    //    // TO DO:  CODE THIS METHO PROPERLY.
    //    return 'Footer Value';
    //}

    // Commented out for VNEXT-1429 (remove old grid)
    //public getFormFieldFor(row: number, col: number): FormField {
    //    let cellName: string = this.getCellNameFor(row, col);
    //    let component: FormFieldBaseComponent = this.runtimeData.dynamicallyCreatedFormFieldsByName[cellName];
    //    return component.FormField;
    //}

    // Commented out for VNEXT-1429 (remove old grid)
    //public getCellNameFor(row: number, col: number): string {
    //    return `t-${row}-${col}`;
    //}

    // Commented out for VNEXT-1429 (remove old grid)
    //public get DeleteGridRowDisabled(): boolean {
    //    return (this.FormField.transientFixedFirstColumnValues != null);
    //}

    // Commented out for VNEXT-1429 (remove old grid)
    //public DynamicComponentHostNameFor(gridRow: GridRowDef, hshColumnDef: FormField, columnIndex: number): string {
    //    // From the previously inline HTML:

    //    let name = this.getCellNameFor(gridRow.RowIndex, hshColumnDef.fieldOrder);

    //    return name;
    //}

    // Commented out for VNEXT-1429 (remove old grid)
    //public getValidationErrorsForCell(row: number, col: number): string[] {
    //    let cellName = this.getCellNameFor(row, col);
    //    let rowErrors: string[] = this.runtimeData.invalidGridRows[row];
    //    if (rowErrors) {
    //        let currentFieldErrors = rowErrors[cellName];
    //        return currentFieldErrors ?? [];
    //    } else {
    //        return [];
    //    }
    //}

    // Commented out for VNEXT-1429 (remove old grid)
    //public get UseAlphaFeatures(): boolean {
    //    return (this.currentSiteService.Site.betaFeaturesEnabled && this.currentUserService.user.isSystemAdmin);
    //}

    // Commented out for VNEXT-1429 (remove old grid)
    //public get UseBetaFeatures(): boolean {
    //    return this.currentSiteService.Site.betaFeaturesEnabled;
    //}

    public set FieldHasValidationError(value: boolean) {
        console.log('setting this.fieldHasValidationError to ', value);
        this.fieldHasValidationError = value;
    }

    public get PageSize(): number {
        return (this.loadingDataProgress.iPageSize);
    }

    public get PageSizeOptions(): number[] {
        return (this.loadingDataProgress.arrPageSizeOptions);
    }

    public get ShowFirstLastButtons(): boolean {
        return (true);
    }

    public get IsLoadingGridData(): boolean {
        return (this.loadingDataProgress.isLoadingGridData);
    }

    public get LoadingDataText(): string {
        return (this.loadingDataProgress.loadingDataMessage);
    }

    public get LoadDataProgressMode(): ProgressBarMode {
        return (ProgressBarConstants.BUFFER_MODE);
    }

    public get LoadDataProgressValue(): number {
        return (this.loadingDataProgress.iLoadingDataProgressValue);
    }

    public get LoadDataProgressBufferValue(): number {
        return (this.loadingDataProgress.iLoadingDataProgressBufferValue);
    }

    public get LoadDataProgressColor(): ThemePalette {
        return (ProgressBarConstants.THEME_PALETTE_PRIMARY);
    }

    public get PaginatorDisabled(): boolean {
        return (this.loadingDataProgress.isLoadingGridData && (this.loadingDataProgress.iLoadingDataProgressValue != 100));
    }

    public FooterCellClass(colIndex: number): string {
        let cellClass: string = 'footer-cell';

        if (colIndex == 0)
            cellClass = 'first-footer-cell';

        return cellClass;
    }
    // End methods called by my HTML code.

    public handleColumnOrderUpdate() {
        this.designChange.emit();
    }

    // Implement base class method getDisplayValue().
    public pseudoStatic_getDisplayValue(formFieldParam: FormField, formInstanceElementParam: FormInstanceElement, gridRow: IGridRow, processingPhase: FormFieldProcessingPhaseEnum): string {
        let fieldTypeAndName: FieldTypeAndName = this.formFieldTypeAndNameService.getFieldTypeAndField(formFieldParam.fieldDefinitionClassName);

        let strValue: string = '';
        if (fieldTypeAndName != null) {
            let fieldDefinition: FieldDefinition = this.fieldDefinitionService.getFieldDefinition(fieldTypeAndName.fieldType);
            let fieldLogicHandler: IFieldDefinitionLogic = fieldDefinition.customLogicHandler;
            strValue = fieldLogicHandler.getDisplayValue(formFieldParam, formInstanceElementParam, gridRow, processingPhase);
        }

        return (strValue);
    }

    // Implement the IGetDisplayValue interface method.
    public isCalculatedField(iColumnIndex: number, formField: FormField): boolean {
        let bIsCalculatedField: boolean = false;

        if ((iColumnIndex >= 0) && (iColumnIndex < this.runtimeMetadata.AllComponentsCount)) {
            let component: FormFieldBaseComponent = this.runtimeMetadata.getAllComponentsFormFieldComponent(iColumnIndex);

            bIsCalculatedField = component.hasCalculatedValue();
        }

        return (bIsCalculatedField);
    }

    // Called from the constructor of GridRowDef
    public getCellDisplayValue(iColIndex: number, formFieldParam: FormField, formInstanceElementWrapperParam: GridFormInstanceElementWrapper, gridRow: IGridRow, processingPhase: FormFieldProcessingPhaseEnum): string {
        let formInstanceElement: FormInstanceElement = formInstanceElementWrapperParam.formInstanceElement;
        let strValue: string = this.pseudoStatic_getDisplayValue(formFieldParam, formInstanceElement, gridRow, processingPhase);
        return (strValue);
    }

    // (formerly named writeValueTriggered)
    protected initalizeComponentFormControl(): void {
        if ((this.Mode === 'preview') || (this.Mode === 'instance')) {
            // Ask my data source to deserialize any JSON grid data (might not be any).
            if (this.FormInstanceElement.childGridRows) {
                this.createConfigFromChildGridRows(this.FormInstanceElement.childGridRows);
            }
            if (this.gridFieldEditorComponent != null) {
                this.gridFieldEditorComponent.parentReceivedFormInstanceElement(this.FormInstanceElement);
            }
        } // if 

        return;
    }

    // Override a method used to get my class. (Required to implement abstract method in FormFieldBaseComponent)
    public getFormFieldClass(): AngularCoreType<any> {
        return (GridFormFieldComponent);
    }

    public formInstanceElementLoaded(formInstanceElement: FormInstanceElement): void {
        if (formInstanceElement.childGridRows) {
            this.createConfigFromChildGridRows(formInstanceElement.childGridRows);
        }
    }

    // HTML accessor methods.
    public get DisplayName(): string {
        let displayName: string = null;

        if (this.FormField && this.FormField.displayName && (this.FormField.displayName.trim() !== '')) {
            displayName = this.FormField.displayName;
        } else {
            displayName = this.FormField.name;
        }

        return displayName;
    }

    public get GridFlavor(): GridFlavorEnum {
        return this.flavor;
    }

    public get FormFieldDisplayHints(): IFormFieldDisplayHint {
        return this.formFieldDisplayHints;
    }

    public get GridColumnDefs(): FormField[] {
        let colDefs = this.gridConfig.CachedGridColumnDefs;


        if (colDefs == null)
            colDefs = this.gridConfig.ColumnDefs;

        return colDefs;
    }

    public set GridColumnDefs(value: FormField[]) {
        if (value == null)
            console.log('GridColumnDefs():  setting CachedGridColumnDefs to null.');

        this.gridConfig.CachedGridColumnDefs = value;
    }

    public GridColumnNames(bIncludeAddColumn: boolean = false): string[] {
        let astrColumnNames: string[] = this.gridConfig.GridColumnNames;
        astrColumnNames = this.GridColumnDefs.map(ff => ff.name);

        if (bIncludeAddColumn) {
            astrColumnNames.push("Add Grid Column");
        }

        return (astrColumnNames);
    }

    public GridColumnDisplayName(columnDef: FormField): string {
        let strDisplayName: string = columnDef.name;

        if ((columnDef !== undefined) &&
            (columnDef !== null) &&
            (columnDef.displayName !== undefined) &&
            (columnDef.displayName !== null) &&
            (columnDef.displayName.trim() !== '')) {
            strDisplayName = columnDef.displayName;
        }

        return (strDisplayName);
    }

    public get GridColumnNamesWithActions(): string[] {
        let astrColumnNames: string[] = this.GridColumnNames(false);

        astrColumnNames.push('Actions');

        return (astrColumnNames);
    }

    public get FieldTypesAndNames(): FieldTypeAndName[] {
        let fieldTypesAndNameFields = this.formFieldTypeAndNameService.getAllGridFieldTypesAndNameFields();
        fieldTypesAndNameFields.sort((a, b) => a.fieldName.localeCompare(b.fieldName));
        return fieldTypesAndNameFields;
    }

    public getColumnTooltip(iColIndex: number, hshColumnDef: FormField): string {
        let columnTooltip: string = ''; // A default value.

        if (hshColumnDef.toolTip && (hshColumnDef.toolTip.trim() !== '')) {
            columnTooltip = hshColumnDef.toolTip;
        }

        return (columnTooltip);
    }

    public get TooltipPosition(): TooltipPosition {
        let position: TooltipPosition = 'below';

        return (position);
    }

    public getColumnTypeIconName(hshColumnDef: FormField): string {
        let strIconName: string = null;

        let fieldTypeAndName: FieldTypeAndName = this.formFieldTypeAndNameService.getFieldTypeAndField(hshColumnDef.fieldDefinitionClassName);
        if (!fieldTypeAndName) {
            let errorMsg: string =
                `GridFormFieldComponent.getColumnTypeIconName():  cannot find a field definition ` +
                `for field class '${hshColumnDef.fieldDefinitionClassName}'.`;
            this.raiseException(errorMsg);
        }
        strIconName = fieldTypeAndName.IconName;

        return (strIconName);
    }

    // pharv - 01/28/2022 - returns the standard class for all cells, plus adds additional ones based
    // on any particular needs of a field type
    public getUnselectedGridRowCellClass(gridRow: any, wrapper: GridFormInstanceElementWrapper): string {
        let cls = 'unselected-grid-row-cell-span';
        if (wrapper.fieldClass == RichTextFieldType) {
            cls += ' rich-text';
        }
        return cls;
    }

    // Called from Form Builder when properties drawer is closed
    public resetFormField(formField: FormField): void {
        if (this.runtimeData.componentBeingEdited != null) {
            if (this.runtimeData.componentBeingEdited != this) {
                this.runtimeData.componentBeingEdited.resetFormField(formField);
            }
            else {
                // Reload my configuration.
                if (this.Mode == 'design') {
                    if ((this.FormField.childFormFields) && (this.FormField.childFormFields.length > 0))
                        this.createGridConfig();
                    else {
                        this.createEmptyGridConfig();
                    }
                }
            }

            this.runtimeData.componentBeingEdited = null;
        }
    }

    // Called when user chooses option from context menu
    public gridCellContextMenuItemClicked(eventData: any, menuItemName: string): void {
        // Get my menu data.
        let menuData: GridCellContextMenuInfo =
            (this.gridCellContextMenu && this.gridCellContextMenu.menuData ?
                <GridCellContextMenuInfo>this.gridCellContextMenu.menuData : null);

        let bSuccess: boolean = false;

        switch (menuItemName) {
            case 'Properties ...':
                {
                    if (menuData && menuData.component) {
                        let hshComponentProperties: any = menuData.component.getProperties();

                        hshComponentProperties['component'] = this;

                        this.onEdit.emit(hshComponentProperties);

                        bSuccess = true;
                    }
                }
                break;

            case 'Delete':
                {
                    if (menuData && menuData.columnDef) {
                        let gridConfigColDef: FormField = this.gridConfig.getColumnDefByName(menuData.columnDef.name);

                        if (gridConfigColDef) {
                            bSuccess = this.gridConfig.removeGridColumn(gridConfigColDef.gridColClientId);
                            if (bSuccess)
                                this.designChange.emit();
                        }
                    }
                }
                break;

            default:
                // Unknown menu item.
                break;
        }

        return;
    }

    public get ContextMenuPositionX(): string {
        let menuData: GridCellContextMenuInfo = (this.gridCellContextMenu && this.gridCellContextMenu.menuData ? <GridCellContextMenuInfo>this.gridCellContextMenu.menuData : null);
        return (menuData ? menuData.contextMenuXPos : '');
    }

    public get ContextMenuPositionY(): string {
        let menuData: GridCellContextMenuInfo = (this.gridCellContextMenu && this.gridCellContextMenu.menuData ? <GridCellContextMenuInfo>this.gridCellContextMenu.menuData : null);
        return (menuData ? menuData.contextMenuYPos : '');
    }

    public onEditSave = (formField: FormField): void => {
        // Note:  deleted some code that was commented out but that can be found in source control.
    }

    // Commented out for VNEXT-1429 (remove old grid)
    // Called when the Form Template's Save button is clicked
    public saveConfiguration(form: any, reasonForSave: FormFieldConfigurationSaveReason): void {
        // Cache form fields during the save configuration operation.
        this.gridConfig.CachedGridColumnDefs = this.gridConfig.ColumnDefs;

        // Call form fields' saveConfiguration() method.
        let allComponentsAndFormFields: ComponentAndFormField[] = this.runtimeMetadata.AllComponents;
        for (let iComponent: number = 0; iComponent < allComponentsAndFormFields.length; iComponent++) {
            let component: FormFieldBaseComponent = allComponentsAndFormFields[iComponent].Component;

            component.saveConfiguration(form, reasonForSave);
        }

        // Save my column definitions as JSON text.
        let currentSite = this.currentSiteService.Site;
        this.FormField.childFormFields = [];

        for (let iCol: number = 0; iCol < this.gridConfig.ColumnCount; iCol++) {
            let gridColDef: FormField = this.gridConfig.getColumnDef(iCol);

            let childFormField: FormField = new FormField();

            childFormField.assignFrom(gridColDef);
            if (childFormField.id < 0)
                childFormField.id = 0;
            FormFieldConstraintLiaisonManager.synchronousUpdateFormFieldWithLatestConstraintValues(this.cachedFormFieldConstraintsService, currentSite.id, childFormField);

            this.FormField.childFormFields.push(childFormField);
        }

        return;
    }

    // Commented out for VNEXT-1429 (remove old grid)
    // Called after a successfuly save of the Form Template to which the Grid belongs
    public saveConfigurationCompleted(form: any): void {
        this.gridConfig.CachedGridColumnDefs = null;

        let allComponentsAndFormFields: ComponentAndFormField[] = this.runtimeMetadata.AllComponents;
        for (let iComponent: number = 0; iComponent < allComponentsAndFormFields.length; iComponent++) {
            let component: FormFieldBaseComponent = allComponentsAndFormFields[iComponent].Component;

            component.saveConfigurationCompleted(form);
        }
    }

    // Called from FormRenderer upon sucessful save of a Form Instance
    public saveCompleted(formInstance: any): void {
        // DOES NOT GET CALLED
    }

    // Called everytime a property is updated on the properties drawer in the Form Builder
    public propertyUpdated(formField: FormField, propertyName: string): void {
        let componentAndFormField: ComponentAndFormField = this.runtimeMetadata.AllComponents.find(cff => cff.FormField.name == formField.name);
        if (componentAndFormField != null) {
            if (propertyName == FormFieldPropertyEnum.FORMULA)
                this.notifyComponentOfFieldNames(componentAndFormField.Component);
            componentAndFormField.Component.propertyUpdated(formField, propertyName);
        }

        // Do we need to handle this property?
        if (propertyName === FormFieldPropertyEnum.FIXED_FIRST_COLUMN_FILE) {
            if (formField.csvOptionsData != null)
                this.processFixedFirstColumnFile(formField.csvOptionsData);
            else {
                // Clear any fixed first column configuration data.
                this.clearAnyFixedFirstColumnConfig();
            }
        }

        return;
    }

    // Called when choosing a CSV to set fixed row headers
    private processFixedFirstColumnFile(csvOptionsData: CsvOptionsFileData): void {
        if ((csvOptionsData != null) && (csvOptionsData.headers != null) && (csvOptionsData.headers.length >= 1)) {
            let fixedValues: FixedFirstColumnValues = FixedFirstColumnValues.createFromHeaderValuePairs(csvOptionsData.headers[0], csvOptionsData.linesOfHeaderValuePairs);

            this.setFirstGridColAsFixedValues(fixedValues);
        }
    }

    // Called when choosing a CSV to set fixed row headers
    private setFirstGridColAsFixedValues(fixedValues: FixedFirstColumnValues): void {
        // Create the fixed column form field.
        let fixedColDef: FormField = (this.gridConfig.ColumnCount == 0 ? this.gridConfig.addGridColumn(ShortTextFieldType) : this.gridConfig.getColumnDef(0));
        fixedColDef.valuesAreFixed = true;
        fixedColDef.displayName = fixedValues.columnName;
        fixedColDef.defaultValue = `${fixedValues.values.length} values`;
        fixedColDef.readOnly = true;
        fixedColDef.fixedFirstColumnJson = JSON.stringify(fixedValues);
        this.FormField.fixedFirstColumnJson = fixedColDef.fixedFirstColumnJson; // Saving this in two places is merely a convenience.
        this.FormField.transientFixedFirstColumnValues = FixedFirstColumnValues.createFromJson(this.gridConfig.getColumnDef(0).fixedFirstColumnJson);
    }

    // Called when clicking the "Clear Fixed Row Heading" button on Form Field Properties drawer
    private clearAnyFixedFirstColumnConfig(): void {
        // Clear any fixed first column configuration data.
        if (this.FormField.fixedFirstColumnJson != null)
            this.FormField.fixedFirstColumnJson = null;
        if (this.FormField.transientFixedFirstColumnValues != null)
            this.FormField.transientFixedFirstColumnValues = null;
        if ((this.FormField.childFormFields != null) && (this.FormField.childFormFields.length >= 1)) {
            let firstChildField: FormField = this.FormField.childFormFields[0];

            if (firstChildField.fixedFirstColumnJson != null)
                firstChildField.fixedFirstColumnJson = null;
            if (firstChildField.valuesAreFixed)
                firstChildField.valuesAreFixed = false;
            if (firstChildField.defaultValue != null)
                firstChildField.defaultValue = null;
        }

        // Recreate my config.
        if ((this.FormField.childFormFields != null) && (this.FormField.childFormFields.length > 0))
            this.createGridConfig();
        else {
            this.createEmptyGridConfig();
        }
    }

    // Implement private helper methods.
    // Commented out for VNEXT-1429 (remove old grid)
    // Called when property on property drawer is updated (called from propertyUpdated())
    private notifyComponentOfFieldNames(component: FormFieldBaseComponent): void {
        // Assemble a hash of all component names.
        let astrFieldNames: string[] = [];
        let hshColNameToFormField: IFieldNameToFormField = {};

        for (let iComponent: number = 0; iComponent < this.runtimeMetadata.AllComponentsCount; iComponent++) {
            let component: FormFieldBaseComponent = this.runtimeMetadata.getAllComponentsFormFieldComponent(iComponent);

            let columnFormField: FormField = this.runtimeMetadata.getAllComponentsFormField(iComponent);
            component.FormField = columnFormField;

            let iCol: number = this.gridConfig.getColumnIndex(columnFormField) + 1;

            let colName: string = `col${iCol}`;
            astrFieldNames.push(colName);

            hshColNameToFormField[colName] = columnFormField;
        }

        component.receiveFormFieldNames(astrFieldNames, hshColNameToFormField);
    }

    // Called on Form Template load
    private createEmptyGridConfig(): void {
        this.gridConfig = new GridConfig(this.Mode, this.flavor, this.flavorModifier, this.fieldDefinitionService, null, null, this.FormField);
    }

    // Called on Form Template load
    private createGridConfig(): void {
        if (this.FormField.childFormFields && (this.FormField.childFormFields.length > 0)) {
            this.gridConfig = new GridConfig(this.Mode, this.flavor, this.flavorModifier, this.fieldDefinitionService, this.FormField.childFormFields, this.formInstance, this.FormField);
            this.gridConfig.setIsFootnote(this.FormField.isFootnote);
        }
    }

    // Called after saving a FormInstance when it reloads
    public createConfigFromChildGridRows(childGridRows: GridRowViewModel[]): void {
        // Create my configuration and load my data.
        this.createGridConfig();
        this.allModesDataSource = new GridAllModesDataSource(this.gridConfig, this);
        this.allModesDataSource.loadGridDataFromViewModelElements(this.fieldDefinitionService, childGridRows);

        // Do we have a footer for numeric totals?
        this.trackColumnTotalsIfSoConfigured();

        // Do we need to show a paginator?
        if (childGridRows.length >= this.loadingDataProgress.arrPageSizeOptions[0]) {
            this.loadingDataProgress.bShowPaginator = true;
        }

        // Update my progress.
        if (this.loadingDataProgress.isLoadingGridData) {
            this.loadingDataProgress.iLoadingDataProgressValue = 100;
            this.loadingDataProgress.iLoadingDataProgressBufferValue = 100;

            // Set a timer to reset my loading flag.
            setTimeout(() => {
                this.loadingDataProgress.isLoadingGridData = false;
            }, 2500);
        }
    }

    private trackColumnTotalsIfSoConfigured(): void {
        // Do we have a footer for numeric totals?
        if (this.FormField.showFooter) {
            // Do we have numeric form fields?
            let numericFFCompPairs: ComponentAndFormField[] = this.runtimeMetadata.AllNumericComponents;

            if (numericFFCompPairs && (numericFFCompPairs.length > 0)) {
                this.allModesDataSource.trackColumnTotals(numericFFCompPairs);
            }
        }
    }

    public copyDataToGrid(pasteData: string, replaceOrAppend: any): void {
        this.allModesDataSource.copyDataToGrid(pasteData, replaceOrAppend, this.runtimeMetadata.AllComponents, this.hasFixedFirstColumnJsonConfig, this.FormField, this.fieldDefinitionService);
    }

    private formFieldConstraintUpdated = (updatedConstraint: IFormFieldConstraint, constraintLiaison: IFormFieldConstraintLiaison): void => {
        // If any of my child form fields use the same constraint, updated their constraint fields accordingly.
        if (constraintLiaison == null) {
            return;
        }
        if (this.gridConfig.ColumnDefs != null) {
            for (let index: number = 0; index < this.gridConfig.ColumnDefs.length; index++) {
                let columnDef: FormField = this.gridConfig.ColumnDefs[index];

                constraintLiaison.updateOtherFieldIfUsingSameConstraint(updatedConstraint, columnDef);
            }
        }

        if ((this.runtimeMetadata != null) && (this.runtimeMetadata.AllComponents != null)) {
            for (let index: number = 0; index < this.runtimeMetadata.AllComponents.length; index++) {
                let componentInfo: ComponentAndFormField = this.runtimeMetadata.AllComponents[index];
                let childFormField: FormField = <FormField>componentInfo.Component.getFormField();

                constraintLiaison.updateOtherFieldIfUsingSameConstraint(updatedConstraint, childFormField);
            }
        }
    }

    private acceptsConstraintUpdateFrom = (formField: FormField): boolean => {
        return formField != this.FormField;
    }

    private removeAnyExistingVirtualColDefs(): void {
        // Remove any existing virtual fields.
        this.FormField.childFormFields = this.FormField.childFormFields.filter(ff => !ff.transientFieldIsVirtual);
    }

    private get instanceOrPreviewChildFormFieldComponents(): FormFieldBaseComponent[] {
        let formFieldComponents: FormFieldBaseComponent[] = [];

        if (this.formFieldComponentsQueryList != null)
            formFieldComponents = this.formFieldComponentsQueryList.toArray();

        return formFieldComponents;
    }

    private get hasFixedFirstColumnJsonConfig(): boolean {
        return ((this.gridConfig != null) && (this.gridConfig.ColumnCount > 0) && (this.gridConfig.getColumnDef(0).fixedFirstColumnJson != null));
    }

    // this.gridFieldEditorComponent is set as a View Child BUT when this component is being used by a Contacts Grid or Attachments Grid
    // there is no View Child. And do those components fire the GridFieldEditor.editorInitialized evennt by calling this method, passing in
    // their gridFieldEditor component 
    public setGridFieldEditorComponent(gridEditor: GridFieldEditorComponent) {
        if (!this.gridFieldEditorComponent)
            this.gridFieldEditorComponent = gridEditor;
    }

    //TEAMS-894: KLW - Needed for grid validation
    public handleEditorGridValidation(state: string) {
        this.mainGridValidation.emit(state);
    }

    //public handleConditionalLogicColumnDefsFilter(filteredColumnDefs: FormField[]): void {
    public handleConditionalLogicColumnDefsFilter(outputData: ConditionalLogicColumnDefsFilterData): void {
        // Set our cached column defs to update our display.
        outputData.filteredColumnDefs.sort((ff1, ff2) => {
            let result: number = 0;

            if (ff1.fieldOrder < ff2.fieldOrder)
                result = -1
            else if (ff1.fieldOrder > ff2.fieldOrder)
                result = 1;

            return result;
        });
        this.gridConfig.CachedGridColumnDefs = outputData.filteredColumnDefs;

        // Begin some rather complicated logic to see if a newly shown column, if any, needs to be put in a different position.
        // See VNEXT-1387 for information on newly shown columns being shown as the last data column regardless of the configured position.
        //
        // Note:  the following method has not been adequately tested and might no longer be necessary.
        // this.fixGridColumnPositionsIfNecessary(outputData);
    }

    // SWH Note: the following method has not been adequately tested and might no longer be necessary.
    //
    //           I am electing to leave the code in the following method in place as it reflects some
    //           amount of research and could be necessary or at least useful in the future.
    private fixGridColumnPositionsIfNecessary(outputData: ConditionalLogicColumnDefsFilterData): void {
        // Begin some rather complicated logic to see if a newly shown column, if any, needs to be put in a different position.
        // See VNEXT-1387 for information on newly shown columns being shown as the last data column regardless of the configured position.
        if (outputData.gridComponent != null) {
            // If we are showing a new field, let's set a timer to allow the grid to show the new field, and then we can see if it's in the correct position.
            if (outputData.showChildField && (outputData.childFieldColumnDef != null)) {
                setTimeout(() => {
                    if ((outputData.gridComponent != null) && (outputData.gridComponent.columns != null)) {
                        let columns = outputData.gridComponent.columns.toArray();

                        // Note:  all of the logic related to the "number of data columns" plus 2/two, relates to the fact that the first column is for reordering and the last for command buttons.
                        if (columns.length == outputData.filteredColumnDefs.length + 2) {
                            console.log('Continue here.');
                            // Note:  if the last column is not in the position it should be, set its order now.
                            // Find the shown column's position.
                            let colIndex: number = 0;
                            let colPositionFound: boolean = false;
                            for (colIndex = 0; colIndex < outputData.filteredColumnDefs.length; colIndex++) {
                                if (outputData.childFieldColumnDef.name == outputData.filteredColumnDefs[colIndex].name) {
                                    colPositionFound = true;
                                    break;
                                }

                            }

                            if (colPositionFound) {
                                let dataColumn: ColumnBase = null;
                                for (let dataColIndex: number = 1; dataColIndex < columns.length - 1; dataColIndex++) {
                                    let colFieldName: string = columns[dataColIndex]['field'];

                                    if (colFieldName == outputData.childFieldColumnDef.name) {
                                        dataColumn = columns[dataColIndex];
                                        if (colIndex + 1 != dataColIndex) {
                                            // Here is the definition of interface ColumnReorderConfig, the optional last parameter to grid component method reorderColumn():
                                            // export interface ColumnReorderConfig {
                                            //     before: boolean; // Indicates whether the reordered column will be positioned before or after the destination index.
                                            // }
                                            outputData.gridComponent.reorderColumn(dataColumn, colIndex + 1);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }, 100);
            }
        }
    }
}
